"use client"

import { create } from "zustand"
import { persist } from "zustand/middleware"

export interface AppNotification {
  id: string
  type: "success" | "error" | "info" | "warning"
  title: string
  message?: string
  timestamp: number
  read: boolean
}

interface NotificationsState {
  items: AppNotification[]
  addNotification: (n: Omit<AppNotification, "id" | "timestamp" | "read">) => void
  markAsRead: (id: string) => void
  markAllAsRead: () => void
  clearAll: () => void
  removeNotification: (id: string) => void
  unreadCount: () => number
}

const MAX_NOTIFICATIONS = 50

function generateId(): string {
  return `notif-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
}

export const useNotificationsStore = create<NotificationsState>()(
  persist(
    (set, get) => ({
      items: [],

      addNotification: (n) => {
        set((state) => {
          const notification: AppNotification = {
            ...n,
            id: generateId(),
            timestamp: Date.now(),
            read: false,
          }
          const items = [notification, ...state.items].slice(0, MAX_NOTIFICATIONS)
          return { items }
        })
      },

      markAsRead: (id) => {
        set((state) => ({
          items: state.items.map((item) =>
            item.id === id ? { ...item, read: true } : item
          ),
        }))
      },

      markAllAsRead: () => {
        set((state) => ({
          items: state.items.map((item) => ({ ...item, read: true })),
        }))
      },

      clearAll: () => {
        set({ items: [] })
      },

      removeNotification: (id) => {
        set((state) => ({
          items: state.items.filter((item) => item.id !== id),
        }))
      },

      unreadCount: () => {
        return get().items.filter((item) => !item.read).length
      },
    }),
    {
      name: "dveriant-notifications",
    }
  )
)
